'use strict';

var GridSendServiceButtonDirective = function GridSendServiceButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-send-service-button.html'),
    controller: 'GridSendServiceButtonController',
    link: function link($scope) {
      $scope.$on('grid:rowSelectionChanged', $scope.onRowSelection);
    }
  };
};
GridSendServiceButtonDirective.$inject = [];
module.exports = GridSendServiceButtonDirective;